// home-editor-05 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Arraste um bloco aqui ou clique": "Arrastre un bloque aquí o haga clic",
    "Como essa linha fica?": "¿Cómo queda esta fila?",
    "Remover linha": "Eliminar fila",
    "Uma arte clicável, sozinha na linha ou dividindo com outra.": "Un arte clicable, solo en la fila o compartiéndola con otro.",
    "Vaga livre": "Espacio libre",
    "Voltar": "Volver",
};

export default catalogo;
